import { assertNever, isTruthy } from 'notable-common';
import { z } from 'zod';
import { FlowVersionTarget } from '../../../../flow/versionTarget.js';
import { FlowProducedType } from '../../../../flowRun/producedType.js';
import { BaseFlowBlockSchema, FlowBlockReturnTypeSchema } from '../../block.js';
import { FlowBlockType } from '../../type.js';
export const FLOW_SUBFLOW_V1_DEFAULT_VERSION_TARGET = FlowVersionTarget.SpecificVersion;
/**
 * Structural validation only. flow-api layers on a lookup of the targeted flow's published version,
 * which needs the database and so cannot live here.
 */
export const FlowSubflowV1BlockConfigSchema = z
    .object({
    // versionTarget and flowId are optional solely to be backwards compatible
    // TODO: Make versionTarget and flowId required once we've migrated all sub-flows to the new strategy
    versionTarget: z.enum(FlowVersionTarget).optional(),
    flowId: z.uuid('A valid flow ID is required').optional(),
    flowDefinitionId: z.uuid('A valid flow definition ID is required').optional(),
    startDataBlockName: z.string().optional(),
})
    .superRefine((config, context) => {
    const { versionTarget } = config;
    if (!isTruthy(versionTarget)) {
        return; // Support legacy block definitions which didn't specify this field
    }
    switch (versionTarget) {
        case FlowVersionTarget.SpecificVersion:
            if (!isTruthy(config.flowDefinitionId)) {
                context.addIssue({
                    code: 'custom',
                    message: `A flow definition must be selected when using versionTarget=${versionTarget}`,
                    path: ['flowDefinitionId'],
                });
            }
            return;
        case FlowVersionTarget.Published:
            if (!isTruthy(config.flowId)) {
                context.addIssue({
                    code: 'custom',
                    message: `A flow must be selected when using versionTarget=${versionTarget}`,
                    path: ['flowId'],
                });
            }
            return;
        default:
            return assertNever('Unhandled flow version target', versionTarget);
    }
});
export const FlowSubflowV1BlockBaseSchema = z.object({
    type: z.literal(FlowBlockType.SubFlowV1),
    returnType: FlowBlockReturnTypeSchema(FlowProducedType.SubFlowV1Result),
    config: FlowSubflowV1BlockConfigSchema,
});
export const FlowSubflowV1BlockSchema = BaseFlowBlockSchema.extend(FlowSubflowV1BlockBaseSchema.shape);
//# sourceMappingURL=config.js.map